// eslint-disable-next-line no-shadow
export enum AuditorActionTypeEnum {
  STRONG = 'strong',
  SATISFACTORY = 'satisfactory',
  NEEDS_IMPROVEMENT = 'needs improvement',
  WEAK = 'weak',
}
